import axios from 'axios';

export default {
  scanStation: axios.create({
    baseURL: process.env.REACT_APP_SCANSTATION_SERVER
  }),
  scanStationUsage : axios.create({
    baseURL: process.env.REACT_APP_SCANSTATION_USAGE_SERVER
  })
}
